export enum MacModifiers {
  Cmd = 'metaKey',
  Ctrl = 'ctrlKey',
  Alt = 'altKey',
  Shift = 'shiftKey',
}

export enum WindowsModifiers {
  Win = 'metaKey',
  Ctrl = 'ctrlKey',
  Alt = 'altKey',
  Shift = 'shiftKey',
}

export enum Keys {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H',
  I = 'I',
  J = 'J',
  K = 'K',
  L = 'L',
  M = 'M',
  N = 'N',
  O = 'O',
  P = 'P',
  Q = 'Q',
  R = 'R',
  S = 'S',
  T = 'T',
  U = 'U',
  V = 'V',
  W = 'W',
  X = 'X',
  Y = 'Y',
  Z = 'Z',
  Zero = '0',
  One = '1',
  Two = '2',
  Three = '3',
  Four = '4',
  Five = '5',
  Six = '6',
  Seven = '7',
  Eight = '8',
  Nine = '9',
  F1 = 'F1',
  F2 = 'F2',
  F3 = 'F3',
  F4 = 'F4',
  F5 = 'F5',
  F6 = 'F6',
  F7 = 'F7',
  F8 = 'F8',
  F9 = 'F9',
  F10 = 'F10',
  F11 = 'F11',
  F12 = 'F12',
  Tab = 'Tab',
  Space = ' ',
  Enter = 'Enter',
  Backspace = 'Backspace',
  Delete = 'Delete',
  Escape = 'Escape',
  Home = 'Home',
  End = 'End',
  PageUp = 'PageUp',
  PageDown = 'PageDown',
  ArrowUp = 'ArrowUp',
  ArrowDown = 'ArrowDown',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
  Backtick = '`',
  Plus = '+',
  Minus = '-',
  Equals = '=',
  LeftBracket = '[',
  RightBracket = ']',
  Backslash = '\\',
  Semicolon = ';',
  Quote = "'",
  Comma = ',',
  Period = '.',
  Slash = '/',
  LessThan = '<',
  GreaterThan = '>',
  NumpadPlus = 'NumpadAdd',
  NumpadMinus = 'NumpadSubtract',
  NumpadMultiply = 'NumpadMultiply',
  NumpadDivide = 'NumpadDivide',
  NumpadDecimal = 'NumpadDecimal',
  NumpadEnter = 'NumpadEnter',
  ContextMenu = 'ContextMenu',
  PrintScreen = 'PrintScreen',
  ScrollLock = 'ScrollLock',
  Pause = 'Pause',
  Insert = 'Insert',
  CapsLock = 'CapsLock',
  NumLock = 'NumLock',
}
